import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css';
import router from './router';
import axios from 'axios';
import { createPinia } from 'pinia'; // ✅ Add this


import 'material-symbols';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const app = createApp(App);
const pinia = createPinia(); // ✅ Create Pinia instance

// ✅ Register Pinia before using any components
app.use(pinia);
app.use(router);
app.mount('#app');

// ✅ Interceptors come *after* app mounting
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.skipRefresh
    ) {
      if (error.response.data.error === 'token_expired') {
        originalRequest._retry = true;
        try {
          const refreshToken = sessionStorage.getItem('refresh_token');
          const API_URL = process.env.VUE_APP_API_URL;
          const refreshTokenResponse = await axios.post(`${API_URL}api/token/refresh/`, {
            refresh_token: refreshToken,
          });

          const newAccessToken = refreshTokenResponse.data.access_token;
          sessionStorage.setItem('access_token', newAccessToken);
          axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axios(originalRequest);
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          return Promise.reject(refreshError);
        }
      } else {
        console.error('Authentication failed:', error.response.data.message);
      }
    }
    return Promise.reject(error);
  }
);
